module.exports = __webpack_public_path__ + "static/media/ProdMgmtFundamentals.06fe796a.jpg";